export default __webpack_public_path__ + "img/sYbstbvi.c9a71892.svg";